import React from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";

// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const Text = ({ blocks, context }) => {
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent context={context} key={blockKey}/>
    ));

    if (childBlocks.length > 0) {
        return (
            <category name='Text' id='text' iconclass='category with-icon-paths snap-icon-text_dual'>{/* NOSONAR */}
                <label text="Text"></label>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }

    return null;
};

Text.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
};

export default Text;